import { connect } from 'react-redux'

import actions from '../../../../../../store/actions'

import ModalAddOrganisations from './ModalAddOrganisations'

export default connect(
  state => ({}),
  dispatch => ({
    upload: (file, opts) => dispatch(actions.library.upload(file, opts))
  })
)(ModalAddOrganisations)
